import { useState } from 'react';
import { Link } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { PageLayout } from '../../../PageLayout';
import { SpecificationsStep } from './SpecificationsStep';
import { PreviewStep } from './PreviewStep';

const stepInfo = [
  { component: SpecificationsStep, title: 'Step 1 of 3: Specifications' },
  { component: PreviewStep, title: 'Step 2 of 3: Preview' },
  { component: PreviewStep, title: 'Done' }
];

export const BulkCreationByAssetFields = () => {
  const [step, setStep] = useState<number>(1);

  const currentStepInfo = stepInfo[step - 1];

  const CurrentStepComponent = currentStepInfo?.component;
  const title = currentStepInfo?.title;

  return (
    <>
      <div className="mt-8 ml-6 -mb-4">
        <Link
          className="text-indigo inline-block relative"
          title="Back to Links"
          to="/link">
          <div className="flex items-center text-small">
            <ArrowBackIosNewIcon sx={{ fontSize: 14 }} />
            &nbsp; Links
          </div>
        </Link>
      </div>
      <PageLayout
        className="w-full min-h-[85vh]"
        dataTestId="bulk-creation-by-asset-fields-page"
        dataCy="bulk-creation-by-asset-fields-card"
        pageTitle="Bulk Add Links by Asset Field">
        {currentStepInfo ? (
          <CurrentStepComponent
            nextStep={() => setStep(step + 1)}
            title={title}
            currentStep={step}
            key={step}
          />
        ) : (
          <div>New Step In Progress</div>
        )}
      </PageLayout>
    </>
  );
};
